<template>
    <div class="query-account">
        <compWrapper
            :title="
                $t('fbb.costmanage.base_info', { defaultValue: '基础信息' })
            "
            theme="primary"
        >
            <compFormEdit
                ref="formEdit"
                class="margin-layout"
                :formdata="getBase"
                v-model="formData"
            ></compFormEdit>
            <template v-if="type != 'query'" slot="footer">
                <Button
                    class="margin-right-20"
                    type="primary"
                    @click="submit"
                    >{{
                        $t("global.common.save", { defaultValue: "保存" })
                    }}</Button
                >
                <Button class="margin-right-20" @click="cancel">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</Button>
            </template>
        </compWrapper>
        <compWrapper
            v-if="handleAuth('fbb.carriergroup.account')"
            :title="
                $t('fbb.carrieraccount.account_info', {
                    defaultValue: '账号信息',
                })
            "
            theme="info"
        >
            <Button
                class="margin-15"
                v-if="type != 'query'"
                type="primary"
                @click="modalProps.show = true"
                >{{
                    $t("erp.product.new_add", { defaultValue: "添加" })
                }}</Button
            >
            <Table
                class="margin-15"
                :columns="accountColumn"
                :data="accountData"
                size="small"
            ></Table>
        </compWrapper>
        <compWrapper
            v-if="handleAuth('fbb.carriergroup.list')"
            :title="
                $t('fbb.warehouse.customer_list', { defaultValue: '客户列表' })
            "
            theme="info"
        >
            <div v-if="type === 'query'">
                <Table
                    class="margin-15"
                    :columns="clientColumn"
                    :data="clientData"
                    size="small"
                ></Table>
            </div>
            <div v-else>
                <vTransfer
                    style="
                        height: 360px;
                        margin: 15px 0px;
                        display: flex;
                        justify-content: center;
                    "
                    :data="client"
                    :target-keys="clientKeys"
                    :list-style="listStyle"
                    :render-format="renderFormat"
                    filterable
                    :filter-method="filterMethod"
                    @on-transfer="handleClientChange"
                ></vTransfer>
            </div>
        </compWrapper>
        <compWrapper
            v-if="type == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog
        ></compWrapper>
        <Modal
            :title="$t('erp.product.new_add', { defaultValue: '添加' })"
            :footerHide="true"
            v-model="modalProps.show"
        >
            <div class="clearfix">
                <Form
                    :labelWidth="100"
                    ref="addAccountForm"
                    :model="addAccountData"
                >
                    <FormItem
                        :label="
                            $t('fbb.carrieraccount.account', {
                                defaultValue: '账号',
                            })
                        "
                        prop="account"
                        :rules="required"
                    >
                        <Input v-model="addAccountData.account" />
                    </FormItem>
                </Form>
                <div class="margin-15 pull-right">
                    <Button
                        class="margin-right-15"
                        type="primary"
                        @click="handleAddAccount"
                        >{{
                            $t("erp.product.new_add", { defaultValue: "添加" })
                        }}</Button
                    >
                    <Button @click="modalProps.show = false">{{
                        $t("global.common.operation_cancel", {
                            defaultValue: "取消",
                        })
                    }}</Button>
                </div>
            </div>
        </Modal>
        <compModal
            v-model="operate.show"
            v-bind="operate"
            @on-confirm="refresh()"
            :closable="false"
        >
            <component
                v-if="operate.component"
                :is="operate.component"
                v-bind="operate"
                v-on="operate.on"
                @on-close="operate = {}"
                @on-update="refresh()"
            />
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetCarrierAccountDetail,
    HttpActiveCarrierAccount,
    HttpUpdateAccountGroup,
    HttpAddAccount,
    HttpCarrierGroupLog
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["querytype", "activeid"],
    components: {
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            id: this.activeid ? this.activeid : this.$route.query.id,
            type: this.querytype ? this.querytype : this.$route.params.type,
            formData: {},
            accountData: [],
            addAccountData: {
                account: "",
            },
            clientData: [],
            client: [],
            clientKeys: [],
            logList: [],
            modalProps: {
                show: false,
            },
            loading: false,
            operate: {
                show: false,
            },
        };
    },
    watch: {
        getSelfmanageorgList: {
            immediate: true,
            handler() {
                this.client = this.getSelfmanageorgList.map((item) => {
                    return {
                        label: item.label,
                        key: item.value,
                    };
                });
            },
        },
    },
    async created() {
        this.loading = true;
        await this.getDetail();
        await this.getLog();
        this.loading = false;
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getSelfmanageorgList",
            "getCountryList"
        ]),

        required() {
            return [
                {
                    required: true,
                    message: this.$t("global.common.fill_required", {
                        defaultValue: "请填写必填项",
                    }),
                },
            ];
        },
        listStyle() {
            return {
                width: "30%",
                minWidth: "260px",
            };
        },
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
        getBase() {
            return [
                {
                    label: this.$t("fbb.carrieraccount.logistics_carrier", {
                        defaultValue: "物流商",
                    }),
                    key: "groupName",
                    tag: "vInput",
                    query: true,
                    required: true,
                },
                {
                    label: this.$t("fbb.carrieraccount.carrieraccount", {
                        defaultValue: "承运商",
                    }),
                    tag: "div",
                    children: (h) => {
                        let carrierItem = this.getCarrierAllList.filter(
                            (item) => {
                                return item.value === this.formData.carrierCode;
                            }
                        )[0];
                        return (
                            <div class="font-bold">
                                {carrierItem ? carrierItem.label : "--"}
                            </div>
                        );
                    },
                    query: true,
                },
                {
                    label:this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.value===this.formData.regionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                    query: true,
                }
            ];
        },
        accountColumn() {
            let commonStartColumns = [
                {
                    title: "No.",
                    type: "index",
                },
            ];
            let commonEndColumns = [
                {
                    title: this.$t("fbb.carrieraccount.account", {
                        defaultValue: "账号",
                    }),
                    key: "account",
                },
                {
                    title: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    render: (h, { row }) => {
                        return row.active === 0 ? (
                            <div>Active</div>
                        ) : (
                            <div>InActive</div>
                        );
                    },
                },
                {
                    title: this.$t("global.common.updatedAt", {
                        defaultValue: "更新时间",
                    }),
                    key: "updatedAt",
                },
            ];
            let operateItem = {
                title: this.$t("global.common.actions", {
                    defaultValue: "操作",
                }),
                render: (h, { row }) => {
                    return (
                        <div>
                            <Dropdown trigger="click">
                                <Button type="primary" size="small">
                                    {this.$t("global.common.actions", {
                                        defaultValue: "操作",
                                    })}
                                    <Icon type="md-arrow-dropdown" />
                                </Button>
                                <DropdownMenu slot="list">
                                    <DropdownItem
                                        class="splitline"
                                        nativeOnClick={this.handleInActiveItem.bind(
                                            this,
                                            row.id,
                                            row.active
                                        )}
                                    >
                                        {row.active === 0
                                            ? this.$t("global.common.failure", {
                                                  defaultValue: "失效",
                                              })
                                            : this.$t(
                                                  "fbb.accountmanage.active",
                                                  { defaultValue: "启用" }
                                              )}
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    );
                },
            };
            let dataColumns = [];
            if (this.type === "query") {
                dataColumns = commonStartColumns.concat(commonEndColumns);
            } else {
                commonStartColumns.push(operateItem);
                dataColumns = commonStartColumns.concat(commonEndColumns);
            }
            console.log("dataColumns", dataColumns);
            return dataColumns;
        },
        clientColumn() {
            return [
                {
                    title: "No",
                    type: "index",
                },
                {
                    title: this.$t("fbb.alloment.client_organization", {
                        defaultValue: "客户",
                    }),
                    render: (h, { row }) => {
                        let clientItem = this.getSelfmanageorgList.filter(
                            (item) => {
                                return item.value === row.organizationId;
                            }
                        )[0];
                        return (
                            <div>{clientItem ? clientItem.label : "--"}</div>
                        );
                    },
                },
            ];
        },
    },
    methods: {
        async getLog () {
            await HttpCarrierGroupLog({
                id: this.id
            }).then(res => {
                this.logList = res.data.orderLogList || [];
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async getDetail() {
            await HttpGetCarrierAccountDetail({
                id: this.id,
            })
                .then(
                    (res) => {
                        this.formData = res.data;
                        this.accountData = res.data.accountList;
                        this.clientData = res.data.organizationList;
                        console.log(res.data.organizationList);
                        this.clientKeys = res.data.organizationList ? res.data.organizationList.map(
                            (item) => {
                                return item.organizationId;
                            }
                        ) : [];
                        console.log(this.clientData, this.clientKeys);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
        },
        handleClientChange(targetKeys, direction, moveKeys) {
            this.clientKeys = targetKeys;
        },

        async handleInActiveItem(id, active) {
            this.operate = {
                title:
                    active === 0
                        ? this.$t("global.common.failure", {
                              defaultValue: "失效",
                          })
                        : this.$t("fbb.accountmanage.active", {
                              defaultValue: "启用",
                          }),
                show: true,
                alert: "warning",
                width: 400,
                showDesc: true,
                params: {
                    id: id,
                },
                ajaxRequest: HttpActiveCarrierAccount,
            };
        },
        async handleAddAccount() {
            let flag = true;
            this.$refs.addAccountForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            await HttpAddAccount({
                groupId: this.id,
                account: this.addAccountData.account,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.addAccountData = {};
                    this.modalProps.show = false;
                    this.refresh();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async submit() {
            // if (!this.formData.test) return this.$VMessage.warning('请填写必填项');
            let flag = await this.$refs.formEdit.validate();
            if (!flag) return;
            this.loading = true;
            await HttpUpdateAccountGroup({
                id: this.id,
                carrierId: this.formData.carrierId,
                groupName: this.formData.groupName,
                orgIds: this.clientKeys,
                regionId:this.formData.regionId
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$router.push({
                            name: "carrierAccount",
                        });
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$router.push({
                name: "carrierAccount",
            });
        },
        async refresh() {
            this.loading = true;
            await this.getDetail();
            await this.getLog();
            this.loading = false;
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod(data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
    },
};
</script>

<style>
</style>
